import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitohyderabadcab() {



  const cardData =
  {
    keyword: 'Mumbai to Hyderabad Cabs ',
    heading: 'Shambhu Cabs: Mumbai to Hyderabad Cabs',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Hyderabad Cabs, providing safe, comfortable, and hassle-free long-distance travel for families, corporate travelers, business professionals, and groups. Our fleet of well-maintained hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Hyderabad with spacious seating and clean interiors. With flexible one-way and round-trip options, experienced chauffeurs, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking assistance, Shambhu Cabs makes your intercity travel stress-free and convenient. For comfort, safety, and dependable long-distance travel, Shambhu Cabs is your trusted choice for Mumbai to Hyderabad cab services.',

    top: 'Top Places to Visit in Hyderabad with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar is Hyderabad’s most iconic monument, built in 1591 by Sultan Muhammad Quli Qutb Shah. The four grand minarets, intricately carved arches, and Islamic-style architecture symbolize the historic charm of Old Hyderabad. The surrounding Laad Bazaar is famous for bangles, perfumes, pearls, and traditional clothing, creating a vibrant cultural atmosphere. Charminar is beautifully lit at night, offering a stunning view of Hyderabad’s heritage."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a majestic hilltop fortress known for its brilliant acoustic system, royal palaces, massive gateways, and ancient water supply techniques. Built in the 16th century, it was the center of the Qutb Shahi dynasty and once famous for producing the world-renowned Kohinoor diamond. The evening Sound & Light Show narrates the fort’s history with captivating visuals, making it a must-visit historical attraction."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City is the world’s largest film studio complex, spread across 2000 acres. Visitors experience large film sets, theme parks, live shows, adventure zones, gardens, and guided studio tours. Known for its cinematic charm, it attracts tourists of all ages and offers exciting activities like bus tours, stunt shows, and behind-the-scenes film experiences. It’s one of India’s most popular family entertainment destinations."
  },
  {
    "title": "Hussain Sagar Lake",
    "description": "Hussain Sagar Lake is Hyderabad’s most beautiful urban lake, famous for its massive monolithic Buddha statue situated on Gibraltar Rock. Visitors enjoy boating, lakeside walks, evening lighting, and views of the Necklace Road skyline. The surrounding parks, restaurants, and viewpoints make it a perfect spot for family outings, photography, and relaxation."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir, made of white Rajasthani marble, sits atop Naubath Pahad offering stunning panoramic views of Hyderabad. Dedicated to Lord Venkateswara, the temple showcases intricate carvings, peaceful surroundings, and elegant architecture. It is one of the most serene and spiritually uplifting spots in the city."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum is one of India’s largest art museums, housing a vast collection of sculptures, weapons, paintings, carpets, clocks, and antiques from across the world. The famous ‘Veiled Rebecca’ statue, double-figure woodwork, rare manuscripts, and global artifacts make this museum a treasure for history and culture lovers. It’s a full-day exploration for anyone interested in world heritage."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace was the official seat of the Nizams of Hyderabad and is admired for its grand courtyards, fountains, regal halls, vintage cars, and royal artifacts. The Khilwat Mubarak (Durbar Hall) with its crystal chandeliers is especially stunning. The palace reflects the grandeur and luxurious lifestyle of Hyderabad’s royal families."
  },
  {
    "title": "Nehru Zoological Park",
    "description": "Spread across 380 acres, Nehru Zoological Park is home to tigers, lions, elephants, rhinos, deer, reptiles, and more than 1000 animals. It offers safari rides, toy train tours, aquariums, butterfly park, and bird enclosures. Perfect for families and nature lovers, it is one of India’s most well-maintained zoos."
  },
  {
    "title": "Qutb Shahi Tombs",
    "description": "Located near Golconda Fort, the Qutb Shahi Tombs are the resting place of the Qutb Shahi rulers. These grand dome-shaped tombs exhibit Persian, Pathan, and Hindu architectural styles. Surrounded by landscaped gardens, they are a peaceful heritage site ideal for photography, history exploration, and cultural insight into Hyderabad’s royal past."
  },
  {
    "title": "Snow World",
    "description": "Snow World is India’s largest indoor snow park, offering snow mountains, slides, ice skating, snow play areas, and snowfall experiences. It provides a refreshing escape from city heat and is especially popular among children and families. The temperature-controlled environment and fun attractions make it a unique recreational spot in Hyderabad."
  },
  {
    "title": "Shilparamam",
    "description": "Shilparamam is a cultural village showcasing India’s traditional crafts, art forms, rural lifestyle, and folk performances. It features handicraft stalls, clay artworks, dance shows, boating, and seasonal festivals. A perfect place to shop for handicrafts and enjoy cultural evenings."
  }
],



"services": [
  {
    "name": "Hyderabad Cab Mumbai",
    "description": "Hyderabad Cab Mumbai provides a reliable and comfortable long-distance cab service for travellers commuting between Mumbai and Hyderabad. This service is ideal for business travellers, families, and long-route passengers seeking a professionally managed car with an experienced driver. With clean and well-maintained vehicles, smooth expressway driving, and transparent fares, the Mumbai-Hyderabad taxi ensures a stress-free intercity travel experience. Whether it's a planned journey or an urgent long-route requirement, the service guarantees timely pickup, highway-trained chauffeurs, and 24×7 booking assistance."
  },
  {
    "name": "Mumbai Hyderabad One-Way Taxi",
    "description": "Mumbai Hyderabad One-Way Taxi offers a cost-effective and convenient choice for travellers who need a single-side drop without paying for a return fare. Ideal for relocations, business travel, student travel, and family journeys, this service includes clean AC cars, professional drivers, and guaranteed on-time pickup from anywhere in Mumbai. With flexible scheduling, instant booking confirmation, and a comfortable travel experience, this one-way cab makes the long Mumbai-Hyderabad route smooth and worry-free."
  },
  {
    "name": "Mumbai to Hyderabad Outstation Cab",
    "description": "Mumbai to Hyderabad Outstation Cab provides dependable intercity travel with options such as sedan, SUV, MUV, and premium cars. Perfect for long outstation trips, this service is suitable for multi-hour journeys requiring comfort, safety, and professional driving expertise. Customers benefit from spacious cars, regular rest stops, GPS-enabled safety, and clear pricing. It is widely chosen for family travel, office trips, medical visits, and extended travel plans."
  },
  {
    "name": "Long Route Cab Mumbai Hyderabad",
    "description": "Long Route Cab Mumbai Hyderabad is specially designed for long-distance travellers who need a safe, relaxed, and seamless journey across states. Drivers are trained for extended highway travel, ensuring smooth driving, proper breaks, and safe arrival. Cars come with comfortable seating, AC climate control, hygiene standards, and ample luggage capacity. This service is ideal for those preferring a private long-route cab instead of buses or flights."
  },
  {
    "name": "Affordable Hyderabad Cab",
    "description": "Affordable Hyderabad Cab provides budget-friendly pricing without compromising service quality. Offering economical sedans and fuel-efficient cars, this option is ideal for budget travellers, students, and frequent intercity riders. Transparent billing, doorstep pickup, clean vehicles, and courteous drivers make the journey comfortable and economical throughout the long route to Hyderabad."
  },
  {
    "name": "AC Taxi Mumbai Hyderabad",
    "description": "AC Taxi Mumbai Hyderabad ensures cool, comfortable, and relaxed long-distance travel with fully air-conditioned cars. Perfect for long journeys across hot regions, this service guarantees refreshing travel even on extended routes. Vehicles undergo regular maintenance, offering smooth rides, clean interiors, and premium comfort for families, executives, and elderly passengers."
  },
  {
    "name": "Sedan Cab Mumbai Hyderabad",
    "description": "Sedan Cab Mumbai Hyderabad offers an ideal travel option for individuals, couples, or small families seeking smooth highway travel. Sedans provide superior comfort, fuel efficiency, and stable ride quality, making them perfect for long hours on the road. This service includes neat interiors, AC comfort, trained drivers, and safe long-distance performance."
  },
  {
    "name": "SUV Cab Mumbai Hyderabad",
    "description": "SUV Cab Mumbai Hyderabad provides extra space, superior stability, and added comfort for long journeys. Perfect for families, large luggage loads, or group travel, SUVs like Ertiga, Innova, and Crysta ensure premium seating, powerful performance, and smooth travel on long routes. The service guarantees a relaxed, spacious, and safe journey throughout the Mumbai-Hyderabad drive."
  },
  {
    "name": "24×7 Cab Mumbai Hyderabad",
    "description": "24×7 Cab Mumbai Hyderabad offers round-the-clock travel availability for urgent, early morning, late-night, or scheduled trips. With trained drivers, well-maintained cars, and fast dispatch support, this service ensures safe and reliable long-distance travel at any hour. It is ideal for business travelers, emergency travel, and people who prefer flexible travel timings."
  },
  {
    "name": "Fastest Hyderabad Route Cab",
    "description": "Fastest Hyderabad Route Cab is tailored for travellers who want the quickest and most efficient route between Mumbai and Hyderabad. Drivers are experienced in choosing the best highways, fastest bypasses, and smoothest travel routes to minimize journey time. This service focuses on punctuality, efficiency, and safe long-distance driving, making it ideal for time-sensitive travellers."
  },
  {
    "name": "Premium Hyderabad Taxi Mumbai",
    "description": "Premium Hyderabad Taxi Mumbai delivers a luxurious long-distance travel experience with high-quality sedans, premium SUVs, and well-trained chauffeurs. Ideal for corporate executives, VIPs, and travellers seeking superior comfort, this service includes plush interiors, smooth rides, bottled water, and courteous service. Designed for travellers needing a top-class experience on the long Mumbai-Hyderabad route."
  },
  {
    "name": "Long Distance Travel Cab",
    "description": "Long Distance Travel Cab offers vehicles and chauffeurs specialized for extended journeys across states. With comfortable seating, sanitized cars, GPS-enabled safety, and smooth driving, this service ensures fatigue-free travel even on routes lasting over 12–15 hours. It is commonly chosen for business tours, family travel, interstate commutes, and relocation trips."
  },
  {
    "name": "Family Cab Mumbai Hyderabad",
    "description": "Family Cab Mumbai Hyderabad is built for comfortable and safe family travel, offering spacious cars, child-friendly arrangements, luggage space, and hygiene assurance. Drivers follow safe driving practices with planned rest stops, making the long route convenient for family members of all ages. This service is perfect for vacations, family visits, and long interstate journeys."
  },
  {
    "name": "Corporate Cab Mumbai Hyderabad",
    "description": "Corporate Cab Mumbai Hyderabad offers professional long-distance travel solutions for executives, corporate travelers, and company employees. Features include timely pickups, uniformed drivers, spacious cars, billing support, and reliable intercity mobility. Ideal for business trips, conferences, and company-sponsored long-route travel."
  },
  {
    "name": "Online Cab Booking Mumbai Hyderabad",
    "description": "Online Cab Booking Mumbai Hyderabad offers instant booking confirmation, transparent fare estimates, vehicle selection options, and secure online payments. Designed for travellers who prefer digital convenience, this service simplifies long-route travel planning with quick online reservations and 24×7 support."
  },
  {
    "name": "Safe Taxi Mumbai Hyderabad",
    "description": "Safe Taxi Mumbai Hyderabad focuses on customer safety during long-distance interstate travel. Cars are sanitized, drivers are background-verified, GPS tracking is enabled, and safe highway driving practices are followed. Ideal for solo travellers, women passengers, senior citizens, and families seeking maximum security."
  },
  {
    "name": "Direct Mumbai Hyderabad Cab",
    "description": "Direct Mumbai Hyderabad Cab provides point-to-point private travel without breaks, diversions, or shared seating. This service ensures uninterrupted travel for those wanting a direct route, making the long journey quicker, safer, and more comfortable. It is ideal for urgent, dedicated, or personal travel needs."
  }
],

"tableData": [
  ["Hyderabad Cab Mumbai", "Mumbai Hyderabad One-Way Taxi"],
  ["Mumbai to Hyderabad Outstation Cab", "Long Route Cab Mumbai Hyderabad"],
  ["Affordable Hyderabad Cab", "AC Taxi Mumbai Hyderabad"],
  ["Sedan Cab Mumbai Hyderabad", "SUV Cab Mumbai Hyderabad"],
  ["24×7 Cab Mumbai Hyderabad", "Fastest Hyderabad Route Cab"],
  ["Premium Hyderabad Taxi Mumbai", "Long Distance Travel Cab"],
  ["Family Cab Mumbai Hyderabad", "Corporate Cab Mumbai Hyderabad"],
  ["Online Cab Booking Mumbai Hyderabad", "Safe Taxi Mumbai Hyderabad"],
  ["Direct Mumbai Hyderabad Cab", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Hyderabad Cabs with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Hyderabad cab services, ideal for long-distance travel, business trips, and family journeys with complete comfort."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, spacious, and air-conditioned cabs that are regularly serviced to ensure a smooth and comfortable ride from Mumbai to Hyderabad."
  },
  {
    "WhyChooseheading": "Experienced Long-Route Drivers",
    "WhyChoosedescription": "Our skilled drivers are familiar with the Mumbai–Hyderabad route, ensuring safe driving, timely arrivals, and a hassle-free travel experience."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Enjoy clear and upfront pricing with no hidden charges—fuel, tolls, and driver allowances included for your Mumbai to Hyderabad cab booking."
  },
  {
    "WhyChooseheading": "24/7 Travel Assistance",
    "WhyChoosedescription": "Our customer support team is available 24/7 to assist with bookings, travel queries, and any help you need during your journey."
  },
  {
    "WhyChooseheading": "Flexible Trip Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized travel plans tailored to your Mumbai to Hyderabad journey requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Cabs",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every trip to provide a safe and hygienic long-distance travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making your Mumbai to Hyderabad travel smooth, comfortable, and worry-free."
  }
]























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab service from Mumbai to Hyderabad?',
    answer: 'Yes, Shambhu Cabs offers reliable cab services from Mumbai to Hyderabad, ensuring a safe, comfortable, and timely journey.',
  },
  {
    question: 'How can I book a cab from Mumbai to Hyderabad?',
    answer: 'You can easily book a cab from Mumbai to Hyderabad through our website, mobile app, or by contacting our 24x7 customer support team for a hassle-free experience.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Hyderabad cab bookings?',
    answer: 'Shambhu Cabs offers a wide range of vehicles including sedans, SUVs, luxury cars, and tempo travellers for group travel from Mumbai to Hyderabad.',
  },
  {
    question: 'Are the drivers experienced for the Mumbai to Hyderabad journey?',
    answer: 'Yes, our drivers are licensed, experienced, and familiar with long-distance routes, ensuring a smooth and safe journey to Hyderabad.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for my Mumbai to Hyderabad cab trip?',
    answer: 'Yes, you can select any pickup and drop-off points in Mumbai and Hyderabad as per your convenience for a personalized travel experience.',
  },
  {
    question: 'Is the Mumbai to Hyderabad cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs offers 24x7 service for the Mumbai to Hyderabad route, allowing you to travel at your preferred time.',
  },
  {
    question: 'Are safety and hygiene protocols followed for the Mumbai to Hyderabad cab journey?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene guidelines to ensure a safe and comfortable journey.',
  },
  {
    question: 'What payment options are available for Mumbai to Hyderabad cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments for Mumbai to Hyderabad cab bookings.',
  },
  {
    question: 'Is customer support available during the Mumbai to Hyderabad trip?',
    answer: 'Yes, Shambhu Cabs provides 24x7 customer support to assist you throughout your journey from Mumbai to Hyderabad.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arvind Kumar',
    feedback: 'Our Mumbai to Hyderabad trip with Shambhu Cabs was fantastic. The driver was professional, the car was comfortable, and we had a smooth journey.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Suman Agarwal',
    feedback: 'I highly recommend Shambhu Cabs for Mumbai to Hyderabad travel. Easy booking, good service, and punctual drivers made our trip enjoyable.',
    rating: 5,
  },
];






































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Hyderabad Cabs",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-hyderabad-cab.jpg",
  "description": "Book reliable Mumbai to Hyderabad cabs with Shambhu Cabs. We offer sedans, SUVs, and AC taxis for one-way trips, outstation travel, corporate rides, and family journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "1050",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-hyderabad-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai to Hyderabad Cabs | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Hyderabad cabs with Shambhu Cabs. Affordable one-way, outstation, family, corporate, and luxury cab services with sedans and SUVs available 24×7."
  />

  <meta
    name="keywords"
    content="Hyderabad Cab Mumbai, Mumbai Hyderabad One-Way Taxi, Mumbai to Hyderabad Outstation Cab, Long Route Cab Mumbai Hyderabad, Affordable Hyderabad Cab, AC Taxi Mumbai Hyderabad, Sedan Cab Mumbai Hyderabad, SUV Cab Mumbai Hyderabad, 24×7 Cab Mumbai Hyderabad, Fastest Hyderabad Route Cab, Premium Hyderabad Taxi Mumbai, Long Distance Travel Cab, Family Cab Mumbai Hyderabad, Corporate Cab Mumbai Hyderabad, Online Cab Booking Mumbai Hyderabad, Safe Taxi Mumbai Hyderabad, Direct Mumbai Hyderabad Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/55.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitohyderabadcab;